import { Link } from "react-router-dom";
import { Fish, Mail } from "lucide-react";
import { Dialog, DialogClose, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { CGUContent } from "@/components/CGUContent";

export default function Footer() {
  return (
    <footer className="mt-20 bg-emerald-950 text-emerald-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12 grid gap-8 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <span className="grid place-items-center w-9 h-9 rounded-xl bg-emerald-600 text-white">
              <Fish className="w-5 h-5" />
            </span>
            <span className="font-display font-extrabold text-lg">PêcheSpot France</span>
          </div>
          <p className="text-sm text-emerald-200/70 max-w-md leading-relaxed">
            Découvrez les meilleurs spots de pêche de France, préparez votre équipement et
            obtenez votre carte de pêche officielle en quelques clics.
          </p>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3 text-white">Explorer</h4>
          <ul className="space-y-2 text-sm text-emerald-200/80">
            <li><Link to="/spots" className="hover:text-white transition-colors">Carte des spots</Link></li>
            <li><Link to="/equipement" className="hover:text-white transition-colors">Équipement & kits</Link></li>
            <li><Link to="/carte-de-peche" className="hover:text-white transition-colors">Carte de pêche</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold mb-3 text-white">Officiel</h4>
          <ul className="space-y-2 text-sm text-emerald-200/80">
            <li><a href="https://www.cartedepeche.fr" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">cartedepeche.fr</a></li>
            <li><a href="https://www.decathlon.fr/tous-les-sports/peche" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Decathlon Pêche</a></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="inline-flex items-center gap-1.5 hover:text-white transition-colors"><Mail className="w-3.5 h-3.5" />Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-emerald-800/50 py-5 text-center text-xs text-emerald-300/60">
        <span data-testid="footer-copyright">© {new Date().getFullYear()} HABILY BOUCHAIB — PêcheSpot France.</span> Données à titre indicatif. Respectez la réglementation locale.
        <Dialog>
          <DialogTrigger asChild>
            <button
              type="button"
              data-testid="footer-cgu-link"
              className="ml-2 text-[10px] text-emerald-300/30 hover:text-emerald-200/70 transition-colors"
            >
              cgu
            </button>
          </DialogTrigger>
          <DialogContent data-testid="cgu-modal" className="max-w-2xl max-h-[85vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle className="font-display">Conditions Générales d'Utilisation</DialogTitle>
            </DialogHeader>
            <CGUContent />
            <DialogClose asChild>
              <Link to="/cgu" data-testid="cgu-modal-full-page-link" className="text-xs text-emerald-700 underline text-left">
                Voir la page complète
              </Link>
            </DialogClose>
          </DialogContent>
        </Dialog>
      </div>
    </footer>
  );
}
